import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the zendeskVerify state domain
 */

const selectZendeskVerifyDomain = state => state.zendeskVerify || initialState;

const makeSelectZendeskVerifyState = () =>
  createSelector(selectZendeskVerifyDomain, subState => subState);

const makeSelectIsVerify = () =>
  createSelector(selectZendeskVerifyDomain, subState => subState.isVerify);

const makeSelectError = () => createSelector(selectZendeskVerifyDomain, subState => subState.error);

export { makeSelectIsVerify, makeSelectError };
